import { Link } from "react-router-dom";
import { categories, siteMeta, siteNav } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold leading-none text-foreground-950">
                瓜
              </span>
              <span className="font-heading text-xl font-bold">{siteMeta.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              {siteMeta.description}
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-accent-300">
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </span>
              {siteMeta.email}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {siteNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="cursor-pointer text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              事件分类
            </h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories
                .filter((item) => item.key !== "全部")
                .map((item) => (
                  <li key={item.key}>
                    <Link
                      to="/topics"
                      className="inline-block cursor-pointer whitespace-nowrap rounded-full border border-background-50/20 px-3 py-1.5 text-xs text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
            </ul>
            <p className="mt-5 rounded-md border border-background-50/15 bg-background-50/5 p-3 text-xs leading-relaxed text-background-300">
              本站内容基于公开材料整理，倡导理性讨论、拒绝网络暴力。涉及未成年人及私人隐私的内容一律不予收录。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteMeta.name} · {siteMeta.slogan}</p>
          <p>所有复盘均可回溯来源，如发现疏漏欢迎通过联系我们页面反馈</p>
        </div>
      </div>
    </footer>
  );
}